import React from 'react'
import DataTable from '../../../../components/DataTable'
import { nameEntity, nameSource } from '../domain/info'
import { headers } from '../domain/headers'
import { breadcrumbList } from '../domain/breadcrumb'
import Container from '../../../../components/Container'
import { toolsList } from '../domain/tools'
import { TUTORIALS_TYPES } from '../../../../common/constants/tutorial-type'
import moment from 'moment'
import { INPUT_MASK } from '../../../../common/constants'
const TutorialsList: React.FC = () => {
  return (
    <>
      <Container
        pageTitle="Listagem"
        breadcrumb={breadcrumbList}
        tools={toolsList}
      >
        <DataTable
          source={nameSource}
          entity={nameEntity}
          format={{ orderBy: 'created_at' }}
          headers={headers}
          notHasChildren
          customHeaders={[
            {
              name: 'Criado em',
              field: 'created_at',
              sortable: false,
              element: item => {
                return (
                  <p>
                    {moment(item?.created_at).format(
                      INPUT_MASK.DATE_LOCALE_WITH_TIME
                    )}
                  </p>
                )
              }
            },
            {
              name: 'Tipo',
              field: 'type',
              sortable: true,
              element: item => {
                return <p>{TUTORIALS_TYPES[item.type]}</p>
              }
            },
            {
              name: 'Informações finais',
              field: 'is_final_process_information',
              sortable: true,
              element: item => {
                return (
                  <p>{item.is_final_process_information ? 'Sim' : 'Não'}</p>
                )
              }
            }
          ]}
        />
      </Container>
    </>
  )
}

export default TutorialsList
